import {
	deepLinkRedirectUrlAtom,
	DEFAULT_LOCALE,
	type InitFlowComponent,
	isValidLocale,
	sessionAtom,
	type SessionData,
	useLocale
} from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { useUserAuthValidation } from '../hooks';

export const IsAuthCodeSetup: InitFlowComponent = ({ fallback, next }) => {
	const { replace, searchParams } = useRouter();
	const token = searchParams.get('token') || '';
	const userId = searchParams.get('userId') || '';
	const deviceUid = searchParams.get('deviceUid') || '';
	const locale = searchParams.get('locale') || DEFAULT_LOCALE;
	const deepLinkRedirectUrl = useAtomValue(deepLinkRedirectUrlAtom);
	const setSessionToken = useSetAtom(sessionAtom);
	const { data, isError, isSuccess } = useUserAuthValidation({
		deviceUid,
		generatedCode: token,
		userId,
		webApp: 'true'
	});
	const { setLocale } = useLocale();

	useEffect(() => {
		if (!token) {
			next();
		}

		if (locale && isValidLocale(locale)) {
			setLocale(locale);
		}

		if (isSuccess) {
			const sessionTokens = {
				deviceUid,
				...data
			} as SessionData;

			setSessionToken(sessionTokens);

			replace(deepLinkRedirectUrl || '/');
		}

		if (isError) {
			next();
		}
	}, [isError, isSuccess, deepLinkRedirectUrl, locale]);

	return fallback;
};
